import React from "react";
import { Link } from "react-router-dom";
import { Dumbbell, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 bg-neutral-950 text-neutral-300">
      <div className="container-fl py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-lg bg-emerald-600 grid place-items-center"><Dumbbell size={18}/></div>
            <span className="font-black text-white text-lg">FitLink Ireland</span>
          </div>
          <p className="text-sm text-neutral-400 leading-relaxed">The premium marketplace for verified personal trainers across Ireland.</p>
        </div>
        <div>
          <div className="overline mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/trainers" className="hover:text-emerald-500">Find Trainers</Link></li>
            <li><Link to="/become-a-trainer" className="hover:text-emerald-500">Become a Trainer</Link></li>
            <li><Link to="/how-it-works" className="hover:text-emerald-500">How It Works</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/terms" className="hover:text-emerald-500">Terms of Service</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-emerald-500">Privacy Policy</Link></li>
            <li><Link to="/legal/cookies" className="hover:text-emerald-500">Cookies</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Contact</div>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Mail size={14}/> hello@fitlink.ie</li>
            <li className="flex items-center gap-2"><MapPin size={14}/> Dublin, Ireland</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800 py-6 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} FitLink Ireland. All rights reserved.
      </div>
    </footer>
  );
}
